module.exports = __webpack_public_path__ + "static/media/joyable4.322dc7cb.jpg";